import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_FAILURE,
  COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_SUCCESS
} from '../constants'

export function* getPossibleActionsSaga( { data: { statusId } } ) {
  try {
    const result = yield call(
      BFFAgent.Commission.getPossibleActions, statusId
    )

    if (result) {
      yield put({
        type: COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_SUCCESS,
        data: result.possible_action
      })
    }
  } catch (error) {
    yield put({
      type: COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_FAILURE,
      data: { error }
    })
  }
}
